import React, { useState, useEffect } from "react";
import "react-phone-number-input/style.css";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Label from "../../components/Label/Label";
import aboutImg from "../../assests/img/about.svg";
import checkedImg from "../../assests/img/checked.svg";
import CustomButton from "../../components/CustomButton/CustomButton";
import Accordion from "react-bootstrap/Accordion";
import Message from "../../util/message";
import HookForm from "../../components/HookForm/HookForm";
import TextField from "../../components/TextField/TextField";
import Constant from "../../util/constant";
import CareerApplyModal from "../../components/CareerApplyModal/CareerApplyModal";
import {
  applyToCareerPosition,
  fetchCareerPage,
} from "../../services/careerApi";
import { getApiErrorMessage } from "../../services/apiClient";
import "./CareerPage.scss";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

const loginForm = {
  email: {
    name: "email",
    validate: {
      required: {
        value: true,
        message: Message.ERRORMESSAGE.EMAILEMPTY,
      },
      pattern: {
        value: Constant.REGEX.email,
        message: Message.ERRORMESSAGE.EMAILINVALID,
      },
    },
  },
};

function CareerPage() {
  const navigate = useNavigate();
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [careerData, setCareerData] = useState(null);
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const loadCareerPage = async () => {
      try {
        const data = await fetchCareerPage();
        setCareerData(data);
      } catch (error) {
        console.error("Failed to load career page", error);
      }
    };

    loadCareerPage();
  }, []);

  const onFormSubmit = () => {};

  const openApplyModal = (position) => {
    setSelectedPosition(position);
    setShowApplyModal(true);
  };

  const handleApplySubmit = async (formData) => {
    const positionId = selectedPosition?.positionId || selectedPosition?.id;

    if (!positionId) {
      return;
    }

    setIsSubmitting(true);

    try {
      await applyToCareerPosition(positionId, formData);
      setShowApplyModal(false);
      setSelectedPosition(null);
      window.alert("Application submitted successfully.");
    } catch (error) {
      window.alert(getApiErrorMessage(error, "Failed to submit application."));
    } finally {
      setIsSubmitting(false);
    }
  };

  const positions = careerData?.openPosition?.positionsData || [];

  if (!careerData) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Seo {...PAGE_SEO.career} />
      <Header handleClick={handleClick} />
      <div className="career_Page">
        <div className="banner-section">
          <div className="content-Top position-absolute">
            <Label title={careerData?.title} className="top-Head"></Label>
            <Label title={careerData?.subTitle} className="top-Inner"></Label>
          </div>
        </div>
        <div className="about-section">
          <div className="left-section">
            <div className="">
              <Label
                className="top"
                title={careerData?.aboutUs?.heading}
              ></Label>
              <Label
                className="inner"
                title={careerData?.aboutUs?.paraOne}
              ></Label>
              <Label
                className="inner"
                title={careerData?.aboutUs?.paraTwo}
              ></Label>

              <div className="know_btn">
                <CustomButton
                  title={careerData?.aboutUs?.btnTitle}
                  onClick={() => navigate("/")}
                />
              </div>
            </div>
          </div>
          <div className="right-section">
            <img src={aboutImg} className="" alt="Careers at Digipank" />
          </div>
        </div>
        <div className="why-section">
          <div className="center-section">
            <div className="right-section">
              <img src={aboutImg} className="" alt="Careers at Digipank" />
            </div>
            <div className="left-section">
              <Label
                className="top"
                title={careerData?.whyUs?.heading}
              ></Label>
              <Label
                className="inner"
                title={careerData?.whyUs?.paragraph}
              ></Label>
              <div className="skills d-flex justify-content-between">
                <ul className="skills-left">
                  {careerData?.whyUs?.points?.slice(0, 4).map((point, index) => (
                    <li key={`left-${index}`}>
                      <img src={checkedImg} className="pl-1" alt="" />
                      {point?.point}
                    </li>
                  ))}
                </ul>
                <ul className="skills-right">
                  {careerData?.whyUs?.points?.slice(4, 8).map((point, index) => (
                    <li key={`right-${index}`}>
                      <img src={checkedImg} className="" alt="Included benefit" />
                      {point?.point}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="know_btn">
                <CustomButton
                  title={careerData?.whyUs?.btnTitle}
                  onClick={() => navigate("/")}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="career-position">
          <div className="top-header">
            <Label
              className="left"
              title={careerData?.openPosition?.heading}
            ></Label>
            <div className="">
              <Label
                className="right"
                title={careerData?.openPosition?.newPosition}
              ></Label>
            </div>
          </div>
          <Accordion defaultActiveKey="0">
            {positions.map((position, index) => (
              <Accordion.Item
                eventKey={String(index)}
                key={position.positionId || position.id || index}
              >
                <Accordion.Header>
                  <span>
                    {position.positionName}
                    <span className="position-absolute exp">
                      {position.experienceRequired}
                    </span>
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  <Label
                    className="job-title paddTop"
                    title={position.jobDescription}
                  ></Label>
                  <Label className="descp" title={position.description}></Label>
                  <Label
                    className="job-title"
                    title={position.keyResponsibilities}
                  ></Label>
                  <ul>
                    {position.responsibilities?.map((item, itemIndex) => (
                      <li className="descp" key={`resp-${itemIndex}`}>
                        {item.point}
                      </li>
                    ))}
                  </ul>
                  <Label
                    className="job-title paddTop"
                    title={position.skillsRequirement}
                  ></Label>
                  <ul>
                    {position.requirements?.map((item, itemIndex) => (
                      <li className="descp" key={`req-${itemIndex}`}>
                        {item.point}
                      </li>
                    ))}
                  </ul>
                  <div className="apply_btn d-flex justify-content-end">
                    <CustomButton
                      title={position.btnTitle || "Apply Now"}
                      onClick={() => openApplyModal(position)}
                    />
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
        <div className="banner-section subscribe-section">
          <div className="content-Top position-absolute">
            <Label
              title={careerData?.subscription?.heading}
              className="top-Head"
            ></Label>
            <Label
              title={careerData?.subscription?.subHeading}
              className="top-Inner"
            ></Label>
            <div className="mail-section">
              <HookForm defaultForm={{}} onSubmit={onFormSubmit}>
                {(formMethod) => {
                  return (
                    <div className="mailInput d-flex">
                      <TextField
                        formMethod={formMethod}
                        rules={loginForm.email.validate}
                        name={loginForm.email.name}
                        errors={formMethod?.errors}
                        autoFocus={true}
                        type="text"
                        placeholder={careerData?.subscription?.emailPlaceholder}
                      />

                      <div className="subs_Btn">
                        <CustomButton
                          title={careerData?.subscription?.subscribeBtn}
                        />
                      </div>
                    </div>
                  );
                }}
              </HookForm>
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
      <CareerApplyModal
        showModal={showApplyModal}
        positionName={selectedPosition?.positionName}
        onHide={() => {
          setShowApplyModal(false);
          setSelectedPosition(null);
        }}
        onSubmit={handleApplySubmit}
        isSubmitting={isSubmitting}
      />
    </div>
  );
}

export default CareerPage;
